
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class FormCard extends Vue {
  @Prop({ type: String, default: "" }) readonly title!: string;
}
